var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.visibleFields),function(field,fieldKey){return _c('FieldComponent',{key:fieldKey,ref:"field",refInFor:true,attrs:{"consumer":_vm.consumer,"field":field},on:{"updateValue":_vm.updateValue,"loading":_vm.loading}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }